import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

/* Order-level jurisdiction resolution + per-service candidates (MLS-SVC-DIR-001) */
export const useMlsJurisdiction = (orderId) => {
  const [resolution, setResolution] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!orderId) return;
    try {
      const res = await axios.get(`${API}/api/orders/${orderId}/mls-jurisdiction`);
      setResolution(res.data);
      setError(null);
    } catch (e) {
      setError(e.response?.data?.detail || 'Failed to load jurisdiction directory');
    } finally { setLoading(false); }
  }, [orderId]);

  useEffect(() => { load(); }, [load]);

  const setJurisdiction = useCallback(async (body) => {
    const res = await axios.put(`${API}/api/orders/${orderId}/mls-jurisdiction`, body);
    setResolution(res.data);
    return res.data;
  }, [orderId]);

  return { resolution, loading, error, reload: load, setJurisdiction };
};
